import React from 'react'

import Sidebar from 'components/Sidebar'

import { Container } from './styles'

const Logged: React.FC = ({ children }) => {
  return (
    <Container>
      <Sidebar />
      {children}
    </Container>
  )
}

export default Logged
